// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const sharePageToInviteGuests = (i) => `Share this page to invite your guests. Guests can then accept/decline etc.`